module.exports = __webpack_public_path__ + "static/fonts/342F4F_F_0.5de86e3.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_F_0.eot
// module id = 54
// module chunks = 4